// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './fieldEditor';
import 'myWorld/uiComponents/index';

/**
 * Input for fields of type timestamp. <br/>
 * Currently just a disabled text input
 * @name TimeFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.TimeFieldEditor = myw.FieldEditor.extend({
    // Fields with type timestamp are disabled.
    // They were meant to be used with generators and they are not handled well in the GUI and
    // in validation at the moment.
    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        this.control = new myw.Input({
            value: this.fieldValue,
            cssClass: 'disabled-input',
            disabled: 'disabled'
        });
        this.setElement(this.control.render().$el);

        //enable firing 'change' event
        this.control.$el.on('input', this._changed.bind(this));
    }
});

export default myw.TimeFieldEditor;
